import { Record } from 'immutable';
import type { FilterDefinitionType } from '~/ducks/machine-filter-v2/data/definitions';
import FilterDefinitionTypeConstants from '~/constants/filter-definition-type-constants';
import NameRecord from '~/ducks/machine-filter-v2/data/NameRecord';
import type {
  SharedFilterFields,
  SharedFilterMethods,
} from '../../types/filter-value-types';

const keys: Fields = {
  filterName: new NameRecord(),
  value: '',
  type: FilterDefinitionTypeConstants.TEXT,
};

export interface Fields extends SharedFilterFields {
  value: string;
  type: FilterDefinitionTypeConstants.TEXT;
}

export default class FreeTextFilterRecord extends Record<Fields>(keys)
  implements SharedFilterMethods {
  constructor(values?) {
    super(values);
    if (values && values.filterDefinition) {
      const fd = values.filterDefinition;
      return this.merge({
        filterName: fd.getNameRecord(),
      });
    }
  }

  getFilterKey() {
    return this.filterName.getName();
  }

  getType() {
    return this.type;
  }
  getName() {
    return this.filterName.getName();
  }

  getLabel() {
    return this.filterName.getLabel();
  }

  getTranslationKey(): string {
    return this.filterName.getTranslationKey() || '';
  }

  getValue() {
    return this.value;
  }

  getValues() {
    return this.value;
  }

  add(value) {
    return this.set('value', value);
  }

  removeValue() {
    return null;
  }

  updateFromDefinition(def: FilterDefinitionType): this {
    return this.set('filterName', def.getNameRecord());
  }
}
